import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fdc66470&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc66470')) {
      api.createRecord('fdc66470', component.options)
    } else {
      api.reload('fdc66470', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fdc66470&", function () {
      api.rerender('fdc66470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ya7mWATbsaJ9/JS/offershelp.vue"
export default component.exports